import { SyntheticEvent, useEffect, useState } from "react";
import { DropdownProps } from "semantic-ui-react";

import { API_KEY_TYPES } from "models";
import { CreateKeyModalFormProps } from "modules/ApiKeys/components";
import { useApiKeyCreate } from "modules/ApiKeys/service";
import { validateEmail } from "util/common";

export const useCreateKeyModalForm = ({ isOpen, onClose }: CreateKeyModalFormProps) => {
  const { mutateAsync: apiReadingKeyCreate, isPending } = useApiKeyCreate();

  const [createAPIKeyTypeId, setCreateAPIKeyTypeId] = useState<API_KEY_TYPES>(API_KEY_TYPES.Read);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [company, setCompany] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);

  const isMissingValue = () => !name || !company || !email || !phone;
  const resetState = () => {
    setName("");
    setEmail("");
    setPhone("");
    setCompany("");
    setFormSubmitted(false);
  };

  const handleAPIKeyTypeDropdownChange = (_: SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => setCreateAPIKeyTypeId(data.value as API_KEY_TYPES);

  const onInputChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = evt.target;
    const setState = { name: setName, company: setCompany, email: setEmail, phone: setPhone }[name];
    setState?.(value);
  };

  const handleSaveApiKey = () => {
    setFormSubmitted(true);

    if (isMissingValue() || !validateEmail(email)) return;

    apiReadingKeyCreate({ name, company_name: company, email, phone_number: phone, type: createAPIKeyTypeId });
    setFormSubmitted(false);
    onClose();
  };

  useEffect(() => {
    if (isOpen) resetState();
  }, [isOpen]);

  return {
    name,
    email,
    phone,
    company,
    formSubmitted,
    isFormSubmitting: isPending,
    createAPIKeyTypeId,
    onInputChange,
    handleSaveApiKey,
    isMissingValue,
    handleAPIKeyTypeDropdownChange
  };
};
